// ===============================================================================
//
//  This file contains the class containing pathnames for the react-app.
//
// ===============================================================================

export class ToxnotReactComponentPaths {

    // ===============================================================================

    public static readonly StartPath = '/Start';

    // ===============================================================================

    public static readonly BaseNewsPath: string = '/News';

    // ===============================================================================
    
    public static readonly BaseNewsLandingPath: string = ToxnotReactComponentPaths.BaseNewsPath + '/Landing';

    // ===============================================================================

    public static readonly ObtainmentReportsPath: string = "/ObtainmentReports";

    // ===============================================================================

    public static readonly BaseNewsArticlePath: string = ToxnotReactComponentPaths.BaseNewsPath + '/Article';

    // ===============================================================================

    public static readonly BaseNewsSearchPath: string = ToxnotReactComponentPaths.BaseNewsPath + '/NewsSearch';
    
    // ===============================================================================


    public static readonly BaseRegulationPath: string = '/regulations';

    // ===============================================================================

    public static readonly BaseRegulationDetailsPath: string = '/regulationDetails';
    
    // ===============================================================================

    public static readonly BaseSharedMaterialsPath: string = '/Exchange';

    // ===============================================================================

    public static readonly BaseSurveyPath: string = '/Survey';

    // ===============================================================================

    public static readonly BaseSurveysPath: string = '/Surveys';

    // ===============================================================================

    public static readonly SharedMaterialsHomeStartPath: string = ToxnotReactComponentPaths.BaseSharedMaterialsPath + '/Start';

    // ===============================================================================

    public static readonly BaseSharedMaterialsDatabasePath: string = ToxnotReactComponentPaths.BaseSharedMaterialsPath + '/Database';

    // ===============================================================================

    public static readonly BaseSharedMaterialsManagementPath: string = ToxnotReactComponentPaths.BaseSharedMaterialsPath + '/Management';

    // ===============================================================================

    public static readonly ContactSupplier: string = ToxnotReactComponentPaths.BaseSharedMaterialsDatabasePath + '/ContactSupplier';

    // ===============================================================================

    public static readonly ShareMaterial: string = ToxnotReactComponentPaths.BaseSharedMaterialsDatabasePath + '/SharePassport';

    // ===============================================================================

    public static readonly SharedMaterialSupplierBase: string = ToxnotReactComponentPaths.BaseSharedMaterialsDatabasePath + '/Supplier';

    // ===============================================================================

    public static readonly SharedMaterialSupplier: string = ToxnotReactComponentPaths.SharedMaterialSupplierBase + '/:ownerId/:companyId?';

    // ===============================================================================

    public static readonly SharedMaterialBaseDetailPath: string = ToxnotReactComponentPaths.BaseSharedMaterialsDatabasePath + '/Detail'

    // ===============================================================================

    public static readonly RequestAccessToSharedMaterial: string = ToxnotReactComponentPaths.BaseSharedMaterialsDatabasePath + '/RequestAccess'

    // ===============================================================================

    public static readonly CompanyPagesManager: string = ToxnotReactComponentPaths.BaseSharedMaterialsManagementPath + '/Brands';

    // ===============================================================================

    public static readonly AccessRequestInbox: string = ToxnotReactComponentPaths.BaseSharedMaterialsManagementPath + '/AccessRequestInbox';

    // ===============================================================================

    public static readonly MyPassports: string = ToxnotReactComponentPaths.BaseSharedMaterialsManagementPath + '/MyPassports';

    // ===============================================================================

    public static readonly GrantGroupAccessInput: string = ToxnotReactComponentPaths.BaseSharedMaterialsManagementPath + '/GrantGroupAccessInput';

    // ===============================================================================

    public static readonly SharedMaterialPublishPreview: string = ToxnotReactComponentPaths.BaseSharedMaterialsPath + '/PublishPreview';

    // ===============================================================================

    public static readonly GetStartedRequestData: string = ToxnotReactComponentPaths.StartPath + '/InviteSuppliers';

    // ===============================================================================

    public static readonly Consult = "/consult/:code";

    // ===============================================================================
    //
    // My Customer Paths
    //

    public static readonly MyCustomersBasePath: string = '/MyCustomers';

    // ===============================================================================

    public static readonly MyCustomersBrowsePath = ToxnotReactComponentPaths.MyCustomersBasePath + '/Browse'

    // ===============================================================================

    public static readonly MyCustomerDetailBasePath: string = ToxnotReactComponentPaths.MyCustomersBrowsePath + '/Customer';

    // ===============================================================================

    public static readonly MyCustomerDetailPath: string = ToxnotReactComponentPaths.MyCustomerDetailBasePath + '/:customerId';

    // ===============================================================================

    public static readonly MyCustomerDetailRequestDetailPath: string = ToxnotReactComponentPaths.MyCustomerDetailBasePath + '/:customerId/Request/:requestId';

    // ===============================================================================

    public static readonly RequestReportsBasePath = ToxnotReactComponentPaths.MyCustomersBasePath + "/RequestReports";

    // ===============================================================================

    public static readonly RequestReportsPath: string = ToxnotReactComponentPaths.RequestReportsBasePath + '/:customUrlName';

    // ===============================================================================

    public static readonly TaskManagementPath: string = '/Tasks';
}
